export const JWT = "authToken";
export const SUCCESS = "success";
export const ERROR = "error";
export const DATE_CONFLICT = "DATE_CONFLICT";
